import { render, staticRenderFns } from "./VerifyDetails.vue?vue&type=template&id=01f37784&scoped=true"
import script from "./VerifyDetails.vue?vue&type=script&lang=js"
export * from "./VerifyDetails.vue?vue&type=script&lang=js"
import style0 from "./VerifyDetails.vue?vue&type=style&index=0&id=01f37784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f37784",
  null
  
)

export default component.exports